import React, { useState, useEffect, useRef } from 'react';
import './ServicesPreview.css';

const ServicesPreview = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="services-preview" className="services-preview-section" ref={sectionRef}>
      <div className="container">
        <div className={`services-preview ${isVisible ? 'fade-in' : ''}`}>
          <div className="services-header">
            <h3 className="services-title text-sm">השירותים הדיגיטליים שלי</h3>
          </div>
          <div className="services-grid">
            <div className="service-card">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" 
                alt="Instagram" 
                className="service-icon-img"
              />
              <span className="service-name">אינסטגרם</span>
            </div>
            <div className="service-card">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/3/34/Ionicons_logo-tiktok.svg" 
                alt="TikTok" 
                className="service-icon-img"
              />
              <span className="service-name">טיקטוק</span>
            </div>
            <div className="service-card">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/b/b9/2023_Facebook_icon.svg" 
                alt="Facebook" 
                className="service-icon-img"
              />
              <span className="service-name">פייסבוק</span>
            </div>
            <div className="service-card">
              <span className="service-emoji">✨</span>
              <span className="service-name">מיתוג</span>
            </div>
            <div className="service-card">
              <span className="service-emoji">📷</span>
              <span className="service-name">עיצוב גרפי</span>
            </div>
            <div className="service-card">
              <span className="service-emoji">📱</span>
              <span className="service-name">ניהול אישי</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;
